(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import { Flex } from "../layout";
var SpinnerWrapper = styled(Flex).withConfig({
  displayName: "Spinner__SpinnerWrapper",
  componentId: "sc-1veqavl-0"
})(["", ""], function (props) {
  if (props.fullscreen) {
    return "\n        flex-direction: column;\n        align-items: center;\n        flex: 1 0 0;\n        &:before {\n          flex: 1 0 0;\n          content: \"\";\n        }\n        &:after {\n          flex: 4 0 0;\n          content: \"\";\n        }\n      ";
  }
});

var Spinner = function Spinner(props) {
  var fullscreen = props.fullscreen;
  var themeContext = useContext(ThemeContext);
  var muiTheme = createTheme({
    palette: {
      primary: {
        main: props.color || themeContext.styles.colors.primaryColor
      }
    }
  });
  return React.createElement(ThemeProvider, {
    theme: muiTheme
  }, React.createElement(SpinnerWrapper, {
    fullscreen: fullscreen
  }, React.createElement(CircularProgress, _extends({}, props, {
    color: "primary"
  }))));
};

__signature__(Spinner, "useContext{themeContext}");

Spinner.propTypes = {
  fullscreen: PropTypes.bool
};
Spinner.defaultProps = {
  fullscreen: false
};
var _default = Spinner;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SpinnerWrapper, "SpinnerWrapper", "/home/vsts/work/1/s/src/components/loaders/Spinner.js");
  reactHotLoader.register(Spinner, "Spinner", "/home/vsts/work/1/s/src/components/loaders/Spinner.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/loaders/Spinner.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();